// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeading\"> Mobile Application </h1> <p>No matter where you are, your account is just a finger tap away with our mobile app. </p> ";
// Exports
export default code;